if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });

        // YPC quick add: keep the hidden variant id, price, image and button in step with the chosen pack.
        this.addEventListener('change', (event) => {
          const input = event.target.closest('[data-qa-variant]');
          if (!input) return;
          const root = input.closest('[data-ypc-qa]');
          const idInput = root.querySelector('input[name="id"]');
          const button = root.querySelector('.ypc-qa__add');
          const label = button && button.querySelector('span');
          const price = root.querySelector('[data-qa-price]');
          const was = root.querySelector('[data-qa-was]');
          const img = root.querySelector('[data-qa-img]');
          const available = input.dataset.available === 'true';
          if (idInput) idInput.value = input.value;
          if (price) price.textContent = input.dataset.price;
          if (was) {
            was.textContent = input.dataset.was || '';
            was.hidden = !input.dataset.was;
          }
          if (img && input.dataset.img) {
            img.removeAttribute('srcset');
            img.src = input.dataset.img;
          }
          if (button) {
            button.disabled = !available;
            button.removeAttribute('aria-disabled');
            if (label) label.textContent = available ? (window.variantStrings ? window.variantStrings.addToCart : 'Add to cart') : (window.variantStrings ? window.variantStrings.soldOut : 'Sold out');
          }
          const error = root.querySelector('.product-form__error-message-wrapper');
          if (error) error.hidden = true;
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const productUrl = opener.getAttribute('data-product-url');
        const sectionUrl = `${productUrl}${productUrl.includes('?') ? '&' : '?'}section_id=ypc-quick-add`;

        fetch(sectionUrl)
          .then((response) => {
            if (!response.ok) throw new Error(`Quick add failed: ${response.status}`);
            return response.text();
          })
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quickAdd = responseHTML.querySelector('[data-ypc-qa]');
            if (!quickAdd) throw new Error('Quick add markup missing');

            this.modalContent.classList.add('ypc-qa-host');
            HTMLUpdateUtility.setInnerHTML(this.modalContent, quickAdd.outerHTML);
            super.show(opener);
          })
          .catch(() => {
            // Never leave the shopper stuck: fall back to the product page.
            window.location.href = productUrl;
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        if (!productElement) return;
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
